import wsEvent from '@/services/events'
import wsGuests from '@/services/events_guests'
import wsTables from '@/services/events_tables'
import wsScheduled from '@/services/events_scheduled_sends'
import wsHistory from '@/services/events_whatsapp_history'

const CACHE_TTL_MS = 15000
const cacheByEvent = new Map()
const inflightByEvent = new Map()

function buildEmptyBundle() {
  return {
    metrics: {},
    guests: [],
    tables: [],
    schedules: [],
    history: []
  }
}

function normalizeBundle(responses) {
  const [metricsResponse, guestsResponse, tablesResponse, scheduledResponse, historyResponse] = responses

  return {
    metrics: metricsResponse && metricsResponse.type === 'success' ? (metricsResponse.data || {}) : {},
    guests: guestsResponse && guestsResponse.type === 'success' ? (guestsResponse.data || []) : [],
    tables: tablesResponse && tablesResponse.type === 'success' ? (tablesResponse.data || []) : [],
    schedules: scheduledResponse && scheduledResponse.type === 'success' ? (scheduledResponse.data || []) : [],
    history: historyResponse && historyResponse.type === 'success' ? (historyResponse.data || []) : []
  }
}

export default {
  async get(eventId, options = {}) {
    const normalizedEventId = Number(eventId || 0)
    const force = !!(options && options.force)

    if (!normalizedEventId) {
      return buildEmptyBundle()
    }

    const cached = cacheByEvent.get(normalizedEventId)
    const now = Date.now()
    if (!force && cached && (now - cached.ts) < CACHE_TTL_MS) {
      return cached.data
    }

    if (!force && inflightByEvent.has(normalizedEventId)) {
      return inflightByEvent.get(normalizedEventId)
    }

    const request = Promise.all([
      wsEvent.getTicketsMetrick(normalizedEventId),
      wsGuests.get({ event_id: normalizedEventId, is_confirm: '', event_table_id: '' }),
      wsTables.get(normalizedEventId),
      wsScheduled.get(normalizedEventId),
      wsHistory.get(normalizedEventId)
    ]).then((responses) => {
      const data = normalizeBundle(responses)
      cacheByEvent.set(normalizedEventId, { ts: Date.now(), data })
      return data
    }).catch(() => {
      const empty = buildEmptyBundle()
      cacheByEvent.set(normalizedEventId, { ts: Date.now(), data: empty })
      return empty
    }).finally(() => {
      inflightByEvent.delete(normalizedEventId)
    })

    inflightByEvent.set(normalizedEventId, request)
    return request
  },

  invalidate(eventId) {
    const normalizedEventId = Number(eventId || 0)
    if (!normalizedEventId) {
      return
    }

    cacheByEvent.delete(normalizedEventId)
    inflightByEvent.delete(normalizedEventId)
  }
}
